__turbopack_context__.v({
  "container": "z4myoa_container",
  "container-repop": "z4myoa_container-repop",
  "ctaButtonWrapper": "z4myoa_ctaButtonWrapper",
  "description": "z4myoa_description",
  "iconText": "z4myoa_iconText",
  "receiptsWrapper": "z4myoa_receiptsWrapper",
  "title": "z4myoa_title",
});
